import React, { Fragment } from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import uuid from 'uuid/v4';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { TAB_MIN_WIDTH, CAC_PROJECT_TITLE_LENGTH } from './CacConstants';
import plusIcon from '../../images/corrcluster/plusIcon.svg';
import clearIcon from '../../images/corrcluster/clearIcon.svg';
import GenericInlineEdit from '../common/GenericInlineEdit';

const CacProjectTabs = ({
  activeProjectId,
  projects,
  addNewProject,
  setActiveProject,
  handleEditTabName,
  openCloseProjectModal,
 }) => {
  const useStylesBootstrap = makeStyles(theme => ({
    tooltip: {
      backgroundColor: theme.palette.common.white,
      color: '#30435D',
      border: '1px solid #ccc',
      margin: '0px',
      fontSize: 11,
      maxWidth: 'none',
    },
  }));

  function BootstrapTooltip(props) {
    const classes = useStylesBootstrap();
    return <Tooltip classes={classes} {...props} />;
  }

  const createTabs = () => {
    const allTabs = projects.map(tab => {
      return (
        <li
          key={uuid()}
          style={{
            minWidth: activeProjectId === tab.projectId && TAB_MIN_WIDTH,
          }}
        >
          <Fragment>
            {activeProjectId === tab.projectId ? (
              <Fragment>
                <BootstrapTooltip title={tab.title}>
                  <div className="tab-active-btn-container">
                    <button type="button" className="tab active">
                      <GenericInlineEdit
                        data-test="inLineEditComponent"
                        validate={text => text.length > 0 && text.length < 61}
                        maxLength={CAC_PROJECT_TITLE_LENGTH}
                        activeClassName="editing"
                        text={tab.title}
                        paramName="newProjectName"
                        style={{
                          backgroundColor: '#94A2B7',
                          color: '#FFFFFF',
                          border: 'none',
                          height: '25px',
                          padding: '4px',
                        }}
                        change={updatedObjectProps =>
                          handleEditTabName(updatedObjectProps)
                        }
                      />
                    </button>
                    <button
                      type="button"
                      className="clear-tab-button"
                      onClick={() => openCloseProjectModal()}
                    >
                      <img
                        src={clearIcon}
                        className="icons"
                        title="Delete"
                        alt="Delete Icon"
                      />
                    </button>
                  </div>
                </BootstrapTooltip>
              </Fragment>
            ) : (
              <BootstrapTooltip title={tab.title}>
                <div className="tab-btn-container">
                  <button
                    type="button"
                    data-test="inActiveTab"
                    className="tab"
                    onClick={() =>
                      setActiveProject(tab.projectId, activeProjectId)
                    }
                  >
                    {tab.title}
                  </button>
                </div>
              </BootstrapTooltip>
            )}
          </Fragment>
        </li>
      );
    });

    return (
      <Fragment>
        <ul className="nav nav-tabs">{allTabs}</ul>
        <BootstrapTooltip title="Add Project">
          <div>
            <button
              type="button"
              className="add-tab-button"
              onClick={addNewProject}
            >
              <img src={plusIcon} className="icons" alt="Add Project" />
            </button>
          </div>
        </BootstrapTooltip>
      </Fragment>
    );
  };
  return (
    <div className="tab-container" data-test="CacProjectTabComponent">
      <div className="tab-content">
        {createTabs()}
      </div>
    </div>);
};

CacProjectTabs.propTypes = {
  projects: PropTypes.instanceOf(Array),
  activeProjectId: PropTypes.number,
  addNewProject: PropTypes.func,
  setActiveProject: PropTypes.func,
  handleEditTabName: PropTypes.func,
  openCloseProjectModal: PropTypes.func,
};

CacProjectTabs.defaultProps = {
  projects: [],
};

export default CacProjectTabs;
